<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">菜单管理</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>系统管理</span>|
					<span class="active">菜单管理</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="action-bar">
				<el-button type="primary" size="mini" style="margin-top: 10px" round @click="showDlg">新增菜单</el-button>
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" border  row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<!-- <el-table-column fixed="left" type="selection" width="55"></el-table-column> -->
				<el-table-column prop="data.menuName" label="菜单名称"></el-table-column>
				<el-table-column align="center" prop="data.menuIcon" label="图标">
					<template slot-scope="scope">
						<i :class="getIcon(scope.row.data?.menuIcon)"></i>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="data.menuSort" label="排序"></el-table-column>
				<el-table-column prop="data.menuUrl" label="菜单URL"></el-table-column>

				<el-table-column fixed="right" align="center" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="复制" placement="top" :enterable="false"><i class="el-icon-document-copy" @click="showDlg(scope.row,'copy')"></i></el-tooltip>
							<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
							<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
								<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
							</el-popconfirm>
						</div>
					</template>
				</el-table-column>
			</el-table>	
		</div>

		<el-dialog :title="!isCopy&form.id > 0 ? '修改菜单' : '新增菜单'" width="630px" center :visible.sync="dlg.active">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="菜单名称" prop="menuName">
					<el-input v-model="form.menuName"></el-input>
				</el-form-item>

				<el-form-item label="上级菜单" prop="parentId">
					<el-cascader :options="list.data" :props="{ label: 'name', value: 'id', checkStrictly: true }" clearable v-model="form.parentId"></el-cascader>
				</el-form-item>		

				<el-form-item v-if="!form.parentId || form.parentId.length === 0" label="图标" prop="menuIcon">
					<el-radio-group v-model="form.menuIcon">
						<el-radio label="1"><i class="icon-work"></i></el-radio>
						<el-radio label="2"><i class="icon-user2"></i></el-radio>
						<el-radio label="3"><i class="icon-chart"></i></el-radio>
						<el-radio label="4"><i class="icon-setting"></i></el-radio>
					</el-radio-group>
				</el-form-item>				

				<el-form-item label="类型" prop="menuType">
					<el-radio-group v-model="form.menuType">
						<el-radio :label="1">菜单</el-radio>
						<el-radio :label="2">目录</el-radio>
					</el-radio-group>
				</el-form-item>

				<el-form-item label="排序" prop="menuSort">
					<div>
						<el-input-number label="排序" :min="0" :max="99" v-model="form.menuSort"></el-input-number>
					</div>
					
				</el-form-item>	

				<el-form-item v-if="form.menuType === 1" label="菜单URL" prop="menuUrl">
					<el-input v-model="form.menuUrl"></el-input>
				</el-form-item>	
				<el-form-item v-if="form.menuType === 1" label="菜单参数" prop="menuParams">
					<el-input v-model="form.menuParams"></el-input>
				</el-form-item>	
				

			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		
		
  </div>
	
			
</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {
	mixins: [mixin],
	data(){
		return {
			dlg: {
				active: false,
				rules: {
					menuName: {required: true, message: '请输入', trigger: 'blur'},
					menuType: {required: true, message: '请选择', trigger: 'change'},
					menuIcon: {required: true, message: '请选择', trigger: 'change'},
					menuSort: {required: true, message: '请选择', trigger: 'change'},
					menuUrl: {required: true, message: '请输入', trigger: 'blur'},
					// menuIds: {required: true, message: '请选择', trigger: 'change'},
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: undefined
			},
			filter: {
				// name: '',
				// departmentId:'',
				pageNumber: 1,
				pageSize: 10
			},
			form: {
				menuName: '',
				menuType: undefined,
				parentId: undefined,
				menuIcon: undefined,
				menuSort: 1,
				menuUrl: undefined
			},
			treeList: undefined,
			isCopy:false,		
		}
	},
	created() {
		this.loadList();
	},
	methods: {
		async loadList() {
			this.isLoading = true;
			let res = await api.getMenuTree(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			// if (res.data) {
			// 	res.data.forEach((item)=>{
			// 		item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
			// 	})
			// 	this.list.data = res.data;
			// }
			this.list.data = res.data;
			this.isLoading = false;
		},
		getTreeIds(tree, nodeId, config) {
			const { children = 'children', id = 'id' } = config || {};
			const toFlatArray = (tree, parentId) => {
				return tree.reduce((t, _) => {
					const child = _[children]
					return [
						...t,
						parentId ? { ..._, parentId } : _,
						...(child && child.length ? toFlatArray(child, _[id]) : [])]
				}, [])
			}
			const getIds = flatArray => {
				let ids = [nodeId]
				let child = flatArray.find(_ => _[id] === nodeId)
				while (child && child.parentId) {
					ids = [child.parentId, ...ids]
					child = flatArray.find(_ => _[id] === child.parentId)
				}
				return ids;
			}
			return getIds(toFlatArray(tree));
		},
		showDlg(item,type) {
			if(type&&type=='copy'){
				this.isCopy=true;
			}
			this.treeList = this.list.data;
			this.form.parentId = 0;
			
			if (item && item.id > 0) {//修改
				this.form.parentId = this.getTreeIds(this.treeList, item.id);
				this.$nextTick(async ()=>{
					let res = await api.getMenu(item.id);
					if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
					// if(type&&type=='copy'){
					// 	this.form={
					// 		...res.data,
					// 	}
						
					// 	console.log(this.form,'--==================ff');
					// }else {
					// 	this.form = res.data;
					// 	console.log(this.form,'--========222--------');

					// }
					this.form = res.data;
					// this.$refs['form'].resetFields();
				});
			} else {//新增
				this.form.id = 0;
				this.form.parentId = undefined;
				this.$nextTick(()=>{
					if (this.$refs['addForm'] !== undefined) {
						this.$refs.addForm.resetFields()
					}

					//清理input数据
					for(let key in this.form){
						this.form[key]=""
					}

				});
			}
			this.dlg.active = true;

		},
		closeDlg() {
			this.dlg.active = false;
		},
		async saveForm() {
			console.log(this.isCopy,'============',this.form.id)
			let res;
			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					let postForm = JSON.parse(JSON.stringify(this.form));
					if(postForm.parentId) postForm.menuIcon = undefined;
					if (postForm.parentId && postForm.parentId.length > 0) {
						postForm.parentId = postForm.parentId[postForm.parentId.length-1];
					}
					if (postForm.menuType === 2) {
						postForm.menuUrl = '';
					}
					if(this.isCopy&&this.form.id>0){
						res = await api.addMenu(postForm);
						this.isCopy = false;
					}else if(this.form.id>0){
						res = await api.editMenu(postForm);
					}else{
						res = await api.addMenu(postForm);
					}
						
					
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			if (this.isLoading) { return;}
			this.isLoading = true;
			let res = await api.delMenu(item.id);
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
    getIcon(icon) {
      switch (+icon) {
        case 1: return 'icon-work';
        case 2: return 'icon-user2';
        case 3: return 'icon-chart';
        case 4: return 'icon-setting';
      }
    }		
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
.table-wrap{
	padding-bottom: 24px;
}
</style>
